export function getAmountToScroll(minutes, hourHeight) {
  if (isNaN(minutes)) {
    console.error(`${minutes} needs to be a number.`);
    return 0;
  }
  let hourHeightNum = 0;
  if (isNaN(hourHeight)) {
    const parsedHourHeight = parseInt(hourHeight, 10);
    if (isNaN(parsedHourHeight)) {
      console.error(`${hourHeight} needs to be a number.`);
      return 0;
    }
    hourHeightNum = parsedHourHeight;
  } else {
    hourHeightNum = hourHeight;
  }

  // this amount doesn't consider the amount of top padding (between calendar start and 12am)
  // which will result in the selected time row to be scrolled down from the calendar header
  // exactly that amount: that's more pleasant that having it glued to the calendar header
  const amountToScroll = Math.round(hourHeightNum * minutes / 60 // row height x minutes normalized
  );
  return amountToScroll;
}